import React from "react";

const removeButtonStyles = {
    fontWeight: "bold",
    fontSize: "140%",
    color: "#bbb",
    cursor: "pointer"
};

const RemoveButton = (props) => (
    <span style={ Object.assign({}, removeButtonStyles, props.style) }
          className={ props.className }
          onClick={props.onClick}>
        <span style={{display: "inline-block", transform:"rotate(45deg)"}}>+</span>
    </span>
);
RemoveButton.propTypes = {
    className: React.PropTypes.string,
    onClick: React.PropTypes.func,
    style: React.PropTypes.object
};

export default RemoveButton;



/** WEBPACK FOOTER **
 ** ./src/main/javascript/recorder/components/RemoveButton.js
 **/